import Table from '@/components/common/table/Table';
import React, { useEffect, useState } from 'react';
import { useSalesFileContext } from '@/context/salesFileContext/SalesFileContextProvider';
import { SearchInput } from '@/components';
import { useDebouncedCallback } from '@/utils/useDebouncedCallback';

const SalesFileTable = () => {
  const {
    salesFileData,
    getSalesFilesAPI,
    totalElements,
    currentPage,
    pageSize,
    setCurrentPage,
    searchQuery,
    setSearchQuery,
    setSortBy,
    sortBy,
    sortDir,
    setSortDir,
  } = useSalesFileContext();
  const [inputValue, setInputValue] = useState('');

  useEffect(() => {
    getSalesFilesAPI();
  }, [searchQuery, currentPage]);

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
  };

  const debouncedSetSearchQuery = useDebouncedCallback((val) => {
    setSearchQuery(val);
    setCurrentPage(0);
  }, 300);

  const handleSearchChange = (e) => {
    const val = e.target.value;
    setInputValue(val);
    debouncedSetSearchQuery.call(val);
  };

  const handleSortChange = ({ field, direction }) => {
    setSortBy(field); // Update the sortBy field
    setSortDir(direction); // Update the sort direction
    getSalesFilesAPI(currentPage, pageSize, searchQuery, field, direction); // Fetch sorted data
  };

  const columns = [
    {
      header: 'File Name',
      render: (file) => file.fileName || 'N/A',
      field: 'fileName',
    },
    {
      header: 'File Date',
      render: (file) => file?.fileDate || 'N/A',
      field: 'fileDate',
    },
    {
      header: 'Year',
      render: (file) => file?.year || 'N/A',
      field: 'year',
    },
    {
      header: 'Months',
      render: (file) =>
        file?.months.length > 0 ? file.months.join(', ') : 'N/A',
      field: 'months',
    },
  ];

  return (
    <div>
      <div className="w-full flex justify-end">
        <SearchInput
          className="w-60"
          value={inputValue}
          onChange={handleSearchChange}
          onSearchClick={handleSearch}
        />
      </div>

      <Table
        columns={columns}
        data={salesFileData}
        totalElements={totalElements}
        pageSize={pageSize}
        currentPage={currentPage}
        onPageChange={(newPage) => setCurrentPage(newPage)}
        onSortChange={handleSortChange} // Pass sorting handler
        sortConfig={{ field: sortBy, direction: sortDir }} // Pass current sorting state
      />
    </div>
  );
};

export default SalesFileTable;
